<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <ApeMenu :menus="menus" />
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'

export default {
  name: 'BonusManagementPerformance',
  components: {
    PageHeaderLayout,
  },
  data() {
    return {
      menus: [
        {
          icon: 'mubiao',
          display_name: '项目组',
          url: '/bonus_management/objectives',
          permission_name: 'pa_kpi_share__group'
        },
        {
          icon: 'fenpei',
          display_name: '总监',
          url: '/bonus_management/director',
          permission_name: 'pa_kpi_share__gm'
        },
        {
          icon: 'bangdan',
          display_name: 'VP',
          url: '/bonus_management/vp',
          permission_name: 'pa_kpi_share__vp'
        },
      ],
    }
  },
}
</script>

<style scoped></style>
